import React, { useState } from 'react';
import classNames from 'classnames';
import MessageContent from './MessageContent';
import ThinkingIcon from '../ThinkingIcon/ThinkingIcon';
import styles from './ConversationPanel.module.css';

interface ReasoningProps {
  reasoning: string;
  hasContent: boolean;
}

const Reasoning: React.FC<ReasoningProps> = ({ reasoning, hasContent }) => {
  const [previewCollapsed, setPreviewCollapsed] = useState(true);

  const isStreaming = !hasContent;

  const reasoningHasTitle =
    reasoning?.length > 0 && reasoning.trim().match(/^\*\*(.*?)\*\*\n/);
  const reasoningTitle = reasoningHasTitle
    ? reasoning.match(/^\*\*(.*?)\*\*\n/)?.[1]
    : isStreaming
    ? 'Planning...'
    : 'Planned';
  const reasoningBody = reasoningHasTitle
    ? reasoning.replace(/^\*\*.*?\*\*\n/, '')
    : reasoning;

  return (
    <div
      className={classNames(
        styles.toolCall,
        styles.toolCallClickable,
        styles.toolCallComplete,
        {
          [styles.toolCallCollapsed]: previewCollapsed,
          [styles.toolCallExpanded]: !previewCollapsed,
        }
      )}
      onClick={() => setPreviewCollapsed(!previewCollapsed)}
    >
      <div className={styles.toolCallHeader}>
        {isStreaming ? (
          <ThinkingIcon />
        ) : (
          <div className={styles.toolCallIcon}>
            <i className={`fa fa-regular fa-thought-bubble`} />
          </div>
        )}
        <div className={styles.toolCallPreviewTitle}>
          <MessageContent body={reasoningTitle || ''} />
        </div>
        <div className={styles.toolCallStatusIcon}>
          <i
            className={classNames('fa fa-regular', {
              'fa-chevron-down': previewCollapsed,
              'fa-chevron-up': !previewCollapsed,
            })}
          />
        </div>
      </div>
      <div className={classNames(styles.toolCallContent)}>
        <MessageContent body={reasoningBody} contentType={'text/markdown'} />
      </div>
    </div>
  );
};

export default Reasoning;
